import React, { ComponentType, ReactElement, useContext } from 'react'
import { Router } from 'react-router-dom'
import { AppRouter } from './AppRouter'

export type RoutingProviderProps = {
    children: ReactElement
    router: AppRouter
}

const Ctx: React.Context<AppRouter> = React.createContext(
    // @ts-ignore
    null as AppRouter
)

const { Provider } = Ctx

export const useRouter = (): AppRouter => useContext<AppRouter>(Ctx)

export const RoutingProvider: ComponentType<RoutingProviderProps> = ({
    children,
    router
}) => {
    if (!router) throw new Error('AppRouter instance not provided')
    return (
        <Router history={router.history}>
            <Provider value={router}>{children}</Provider>
        </Router>
    )
}
